import app from './app';

// english
export default {
  app,
};
